<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="pageTitle"
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="backPage"/>
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (showPageLoader) {
      <tidy-loader style="display: flex; justify-content: center;" />
    }

    @if (!showPageLoader) {
      <div class="custom-tabs">
        <div
          class="tab-item"
          [class.active]="selectedTab === 'assign'"
          (click)="selectTab('assign')">
          {{'Assign Pro' | translate}}
        </div>
        <div
          class="tab-item"
          [class.active]="selectedTab === 'request'"
          (click)="selectTab('request')">
          {{'Send Job Request' | translate}}
        </div>
      </div>
      @if (windowService.isDesktopRes) {
        <tidy-row>
          <form [formGroup]="form" novalidate action="#">
            <div style="display: flex; justify-content: space-between">
              <tidy-select
                [label]="'Property'"
                [items]="propertyItems"
                [form]="form.controls.address"
                formControlName="address"
                (optionChange)="changeAddress()"
                [icon]="'assets/svg/home.svg'"
                style="flex: 1; padding-right: 5px;"
                class="select-property-input" />
              <tidy-select
                [label]="'Service Type'"
                [items]="serviceTypeItems"
                [form]="form.controls.serviceType"
                [selectedItem]="selectedServiceType"
                formControlName="serviceType"
                [icon]="'assets/svg/briefcase-outline.svg'"
                style="flex: 1; padding-left: 5px;"
                class="select-property-input"
                (optionChange)="changeServiceType()" />
            </div>
          </form>
        </tidy-row>
      }
      @if (!windowService.isDesktopRes) {
        <tidy-row>
          <form [formGroup]="form" novalidate action="#">
            <tidy-select
              [label]="'Property'"
              [items]="propertyItems"
              [form]="form.controls.address"
              formControlName="address"
              (optionChange)="changeAddress()"
              [icon]="'assets/svg/home.svg'"
              class="select-property-input" />
          </form>
        </tidy-row>
        <tidy-row>
          <form [formGroup]="form" novalidate action="#">
            <tidy-select
              [label]="'Service Type'"
              [items]="serviceTypeItems"
              [form]="form.controls.serviceType"
              [selectedItem]="selectedServiceType"
              formControlName="serviceType"
              [icon]="'assets/svg/briefcase-outline.svg'"
              class="select-property-input"
              (optionChange)="changeServiceType()" />
          </form>
        </tidy-row>
      }
      @if (showLoader) {
        <tidy-loader style="display: flex; justify-content: center;" />
      }
      @if (!showLoader) {
        @if (selectedTab == 'request') {
          <tidy-row>
            <form [formGroup]="form" novalidate action="#">
              <tidy-select
                [label]="'Pro'"
                [icon]="'assets/svg/person.svg'"
                [form]="form.controls.pro"
                formControlName="pro"
                [items]="proItems"
                (optionChange)="changePro($event)" />
            </form>
          </tidy-row>
          @if (showProChangeLoader) {
            <tidy-loader style="display: flex; justify-content: center;" />
          }
          @if (!showProChangeLoader && selectedPro) {
            @if (form?.value?.pro == 'all_my_pros') {
              <tidy-row [align]="'center'" style="margin-top: -10px">
                <tidy-text
                  [smallHelper]="priorityListSentence" /><span>&nbsp;</span>
                  <tidy-text
                    [smallHelper]="'Edit Workflow'"
                    (action)="goToJobRequestWorkflows()"
                    class="link" />
                </tidy-row>
              }
              @if (windowService.isDesktopRes) {
                <tidy-row>
                  <form [formGroup]="form" novalidate action="#">
                    <div style="display: flex; justify-content: space-between">
                      <tidy-select
                        [label]="'Service'"
                        [icon]="'assets/svg/time.svg'"
                        [form]="form.controls.service"
                        formControlName="service"
                        [items]="proServiceItems"
                        trackBy="trackByFn"
                        style="flex: 1; padding-right: 5px;"
                        (optionChange)="changeService($event)" />
                      <tidy-select
                        [label]="'Frequency'"
                        [icon]="'assets/svg/time.svg'"
                        [form]="form.controls.frequency"
                        formControlName="frequency"
                        [items]="frequencyItems"
                        style="flex: 1; padding-left: 5px;"
                        (optionChange)="selectFrequency($event)" />
                    </div>
                  </form>
                </tidy-row>
              }
              @if (!windowService.isDesktopRes) {
                <tidy-row>
                  <form [formGroup]="form" novalidate action="#">
                    <tidy-select
                      [label]="'Service'"
                      [icon]="'assets/svg/time.svg'"
                      [form]="form.controls.service"
                      formControlName="service"
                      [items]="proServiceItems"
                      trackBy="trackByFn"
                      (optionChange)="changeService($event)" />
                  </form>
                </tidy-row>
                <tidy-row>
                  <form [formGroup]="form" novalidate action="#">
                    <tidy-select
                      [label]="'Frequency'"
                      [icon]="'assets/svg/time.svg'"
                      [form]="form.controls.frequency"
                      formControlName="frequency"
                      [items]="frequencyItems"
                      (optionChange)="selectFrequency($event)" />
                  </form>
                </tidy-row>
              }
              @if (showServiceChangeLoader) {
                <tidy-loader style="display: flex; justify-content: center;" />
              }
              @if (!showServiceChangeLoader) {
                @if (form?.value?.pro !== 'all_my_pros') {
                  @for (day of displayedRequestableDays; track day; let dayIndex = $index) {
                    <tidy-card>
                      <tidy-row class="vertical-align-center">
                        <ng-container [formGroup]="weekDayCheckBox[dayIndex]">
                          <tidy-checkbox
                            [items]="[{viewValue: day?.displayFormat, value: true}]"
                            (checkedChange)="markCheckbox($event, dayIndex)"
                            formControlName="checked"
                            [checked]="weekDayCheckBox[dayIndex].value.checked"
                            [initValue]="weekDayCheckBox[dayIndex].value.checked" />
                        </ng-container>
                      </tidy-row>
                      @for (formGrp of timeRangeForms[dayIndex]; track formGrp; let i = $index) {
                        <tidy-row>
                          <tidy-two-column-row [formGroup]="formGrp">
                            <tidy-select
                              style="max-width: 35%; margin: 0;"
                              [icon]="'assets/svg/time.svg'"
                              [label]="'Time'"
                              [form]="formGrp.controls.start_time"
                              formControlName="start_time"
                              [submitted]="submitted"
                              (optionChange)="updateValuesValidity(dayIndex); startTimeChange(formGrp)"
                              [items]="dayIndex === 0 ? todayAvailabilityRequesTimeItems : availabilityRequestTimeItems" />
                            <span style="align-self: center; justify-content: space-around; max-width: 10%;">-</span>
                            <tidy-select
                              style="max-width: 35%; margin-right: 10px;"
                              [icon]="'assets/svg/time.svg'"
                              [label]="'Time'"
                              [form]="formGrp.controls.end_time"
                              formControlName="end_time"
                              [submitted]="submitted"
                              (optionChange)="updateValuesValidity(dayIndex)"
                              [items]="endTimes(formGrp.value.start_time)" />
                            <div style="margin-left: auto; display: flex; gap: 8px; margin-left: 10px">
                              <tidy-image (action)="removeTimeRange(dayIndex, i)" src="assets/img/trash-icon-outline.svg" class="icon body-size" style="max-width: 16px; align-self: center;" />
                              <tidy-image (action)="addNewTimeRange(dayIndex)" src="assets/img/add.svg" class="icon body-size" style="max-width: 16px; align-self: center; opacity: .6;" />
                            </div>
                          </tidy-two-column-row>
                        </tidy-row>
                      }
                    </tidy-card>
                  }
                  @if (!showAllDays && requestableDays && requestableDays.length > 5) {
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [body]="'View More Days'"
                        (action)="viewMoreDays()"
                        class="link" />
                    </tidy-row>
                  }
                }
                @if (form?.value?.pro == 'all_my_pros') {
                  @if (windowService.isDesktopRes) {
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <div style="display: flex; justify-content: space-between">
                          <tidy-datepicker
                            #noEarlierDate
                            [label]="'Earliest Start Date'"
                            [icon]="'assets/svg/calendar.svg'"
                            formControlName="noEarlierDate"
                            [form]="form.controls.noEarlierDate"
                            errorMessage="Please enter a date."
                            [noPastDates]="true"
                            (optionChange)="earlierDateChange($event)"
                            [submitted]="submitted"
                            style="flex: 1; padding-right: 5px;" />
                          <tidy-select
                            [icon]="'assets/svg/time.svg'"
                            [label]="'Earliest Start Time'"
                            [items]="noEarlierTimes"
                            [form]="form.controls.noEarlierTime"
                            formControlName="noEarlierTime"
                            (optionChange)="selectNoEarlierTime($event)"
                            errorMessage="Please enter a time."
                            [hideSearch]="true"
                            [submitted]="submitted"
                            style="flex: 1; padding-left: 5px;" />
                        </div>
                      </form>
                    </tidy-row>
                  }
                  @if (!windowService.isDesktopRes) {
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <tidy-datepicker
                          #noEarlierDate
                          [label]="'Earliest Start Date'"
                          [icon]="'assets/svg/calendar.svg'"
                          formControlName="noEarlierDate"
                          [form]="form.controls.noEarlierDate"
                          errorMessage="Please enter a date."
                          [noPastDates]="true"
                          (optionChange)="earlierDateChange($event)"
                          [submitted]="submitted" />
                      </form>
                    </tidy-row>
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <tidy-select
                          [icon]="'assets/svg/time.svg'"
                          [label]="'Earliest Start Time'"
                          [items]="noEarlierTimes"
                          [form]="form.controls.noEarlierTime"
                          formControlName="noEarlierTime"
                          (optionChange)="selectNoEarlierTime($event)"
                          errorMessage="Please enter a time."
                          [hideSearch]="true"
                          [submitted]="submitted" />
                      </form>
                    </tidy-row>
                  }
                  @if (tooFarStartDateError) {
                    <tidy-error-message
                      [text]="'Please select an earliest start date no more than 3 days before the latest finish date.'" />
                  }
                  @if (windowService.isDesktopRes) {
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <div style="display: flex; justify-content: space-between">
                          <tidy-datepicker
                            [label]="'Latest Finish Date'"
                            [icon]="'assets/svg/calendar.svg'"
                            formControlName="noLaterDate"
                            [form]="form.controls.noLaterDate"
                            errorMessage="Please enter a date."
                            [minDate]="form.controls.noEarlierDate.value"
                            (optionChange)="updateNoLaterOpts()"
                            [submitted]="submitted"
                            style="flex: 1; padding-right: 5px;" />
                          <tidy-select
                            [icon]="'assets/svg/time.svg'"
                            [label]="'Latest Finish Time'"
                            [items]="noLaterTimes"
                            [form]="form.controls.noLaterTime"
                            formControlName="noLaterTime"
                            (optionChange)="selectNoLaterTime($event)"
                            errorMessage="Please enter a time."
                            [hideSearch]="true"
                            [submitted]="submitted"
                            style="flex: 1; padding-left: 5px;" />
                        </div>
                      </form>
                    </tidy-row>
                  }
                  @if (!windowService.isDesktopRes) {
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <tidy-datepicker
                          [label]="'Latest Finish Date'"
                          [icon]="'assets/svg/calendar.svg'"
                          formControlName="noLaterDate"
                          [form]="form.controls.noLaterDate"
                          errorMessage="Please enter a date."
                          [minDate]="form.controls.noEarlierDate.value"
                          (optionChange)="updateNoLaterOpts()"
                          [submitted]="submitted" />
                      </form>
                    </tidy-row>
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <tidy-select
                          [icon]="'assets/svg/time.svg'"
                          [label]="'Latest Finish Time'"
                          [items]="noLaterTimes"
                          [form]="form.controls.noLaterTime"
                          formControlName="noLaterTime"
                          (optionChange)="selectNoLaterTime($event)"
                          errorMessage="Please enter a time."
                          [hideSearch]="true"
                          [submitted]="submitted" />
                      </form>
                    </tidy-row>
                  }
                  @if (showSameDayTimeAlert) {
                    <tidy-row [align]="'center'" style="margin-top: -10px">
                      <tidy-text
                        [smallHelper]="'<b>Note:</b> You selected times today. If a pro accepts a time today <u>the price will be +50%.</u>'" />
                    </tidy-row>
                  }
                  @if (showTimesError) {
                    <tidy-row [align]="'center'">
                      <tidy-text
                        [smallHelper]="'<b>Note:</b> TIDY\'s Find New Pros feature only works for start times of 8:00am or later, end times of 11:00pm or earlier, and at least'" /><span>&nbsp;</span>
                        <tidy-text
                          [smallHelper]="timesErrorText" />
                      </tidy-row>
                    }
                    @if (form?.value?.frequency == 'once') {
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-textarea
                            formControlName="jobNote"
                            [form]="form.controls.jobNote"
                            label="Job note (optional)"
                            [icon]="'assets/svg/information-circle.svg'" />
                        </form>
                      </tidy-row>
                    }
                  }
                  @if (forms) {
                    <dynamic-booking-form
                      #dynamicBookingForm
                      [forms]="forms"
                      [submitted]="submitted"
                      [hasImageUploadError]="hasImageUploadError"
                      [isLoading]="isLoadingDynamicForm"
                      (attachmentsChange)="onAttachmentsChange($event)"
                      (selectedCheckboxesChange)="onSelectedCheckboxesChange($event)"
                      (formDataChange)="onFormDataChange($event)" />
                  }
                }
              }
              @if (form?.value?.pro == 'add_pro') {
                <tidy-card>
                  <tidy-row>
                    <tidy-text
                      [body]="('Add a new pro to your ' | translate) + selectedServiceType?.viewValue.toLowerCase() + (' workflow at ' | translate) + (selectedAddress?.address_name ? (selectedAddress.address_name | translate) : (selectedAddress.address1 | translate)) + ':'" />
                  </tidy-row>
                  <tidy-row>
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-input
                        formControlName="newProName"
                        [label]="'Pro Name'"
                        [form]="form.controls.newProName"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a name.'"
                        [icon]="'assets/svg/person.svg'"
                        [activeIcon]="'assets/svg/person-outline-tidy-green.svg'" />
                    </form>
                  </tidy-row>
                  <tidy-row>
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-input
                        formControlName="newProEmail"
                        [label]="'Pro Email'"
                        [form]="form.controls.newProEmail"
                        type="email"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a valid email.'"
                        [icon]="'assets/svg/mail.svg'" />
                    </form>
                  </tidy-row>
                  <tidy-row>
                    <form [formGroup]="form" novalidate action="#">
                      <tidy-input-international-phone
                        formControlName="newProPhone"
                        [label]="'Pro Phone'"
                        [form]="form.controls.newProPhone"
                        [inputMode]="'numeric'"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a valid phone.'"
                        [icon]="'assets/svg/phone-portrait.svg'"
                        [initialMask]="{ mask: '[00000000000000000000000]' }"
                        (countryCodeChange)="onCountryCodeChange($event)" />
                    </form>
                  </tidy-row>
                  <tidy-button
                    [text]="'Add Pro'"
                    [action]="boundAddNewPro"
                    class="secondary" />
                </tidy-card>
              }
            }
            @if (selectedTab == 'assign') {
              @if (proItems?.length) {
                <tidy-row>
                  <form [formGroup]="form" novalidate action="#">
                    <tidy-select
                      [label]="'Pro'"
                      [icon]="'assets/svg/person.svg'"
                      [form]="form.controls.pro"
                      formControlName="pro"
                      [items]="proItems"
                      (optionChange)="changePro($event)" />
                  </form>
                </tidy-row>
                @if (showProChangeLoader) {
                  <tidy-loader style="display: flex; justify-content: center;" />
                }
                @if (selectedPro && !selectedPro?.isPrivate && !showProChangeLoader) {
                  <tidy-row [align]="'center'" style="margin-top: -5px; margin-bottom: 20px">
                    <tidy-text
                      [helper]="'This pro does not allow assignments.'" />
                  </tidy-row>
                }
                @if (proServiceItems?.length && !showProChangeLoader && selectedPro?.isPrivate) {
                  @if (windowService.isDesktopRes) {
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <div style="display: flex; justify-content: space-between">
                          <tidy-select
                            [label]="'Service'"
                            [icon]="'assets/svg/time.svg'"
                            [form]="form.controls.service"
                            formControlName="service"
                            [items]="proServiceItems"
                            trackBy="trackByFn"
                            style="flex: 1; padding-right: 5px;"
                            (optionChange)="changeService($event)" />
                          <tidy-select
                            [label]="'Frequency'"
                            [icon]="'assets/svg/time.svg'"
                            [form]="form.controls.frequency"
                            formControlName="frequency"
                            [items]="frequencyItems"
                            style="flex: 1; padding-left: 5px;"
                            (optionChange)="selectFrequency($event)" />
                        </div>
                      </form>
                    </tidy-row>
                  }
                  @if (!windowService.isDesktopRes) {
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <tidy-select
                          [label]="'Service'"
                          [icon]="'assets/svg/time.svg'"
                          [form]="form.controls.service"
                          formControlName="service"
                          [items]="proServiceItems"
                          trackBy="trackByFn"
                          (optionChange)="changeService($event)" />
                      </form>
                    </tidy-row>
                    <tidy-row>
                      <form [formGroup]="form" novalidate action="#">
                        <tidy-select
                          [label]="'Frequency'"
                          [icon]="'assets/svg/time.svg'"
                          [form]="form.controls.frequency"
                          formControlName="frequency"
                          [items]="frequencyItems"
                          (optionChange)="selectFrequency($event)" />
                      </form>
                    </tidy-row>
                  }
                  @if (!selectedService?.isBasePriceAllowedToBook) {
                    <tidy-card>
                      <tidy-row class="extra-bottom-padding">
                        <tidy-image
                          [src]="'assets/img/request-failed.svg'"
                          class="header-size" />
                        <tidy-text
                          [header]="'Your Price is Low'" />
                      </tidy-row>
                      <tidy-row class="extra-bottom-padding">
                        <tidy-text
                          [body]="'Your price for this service is lower than the pro\’s price so it is less likely they will accept your request. You can keep your price the same or increase it.'" />
                      </tidy-row>
                      <tidy-button
                        [text]="('Change My Rate to ' | translate) + (selectedService?.prices?.lowestPossibleBasePrice | tcurrency)"
                        [action]="boundChangeServiceRates"
                        class="secondary" />
                    </tidy-card>
                  }
                  @if (showServiceChangeLoader) {
                    <tidy-loader style="display: flex; justify-content: center;" />
                  }
                  @if (!showServiceChangeLoader) {
                    @if (windowService.isDesktopRes) {
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <div style="display: flex; justify-content: space-between">
                            <tidy-datepicker
                              [label]="firstJobDateLabel"
                              [icon]="'assets/svg/calendar.svg'"
                              formControlName="jobDate"
                              [form]="form.controls.jobDate"
                              errorMessage="Please enter a valid date."
                              [submitted]="submitted"
                              style="flex: 1; padding-right: 5px;" />
                            <tidy-select
                              [label]="firstJobTimeLabel"
                              [icon]="'assets/svg/time.svg'"
                              [form]="form.controls.jobTime"
                              formControlName="jobTime"
                              [items]="assignJobTimeItems"
                              style="flex: 1; padding-left: 5px;" />
                          </div>
                        </form>
                      </tidy-row>
                    }
                    @if (!windowService.isDesktopRes) {
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-datepicker
                            [label]="firstJobDateLabel"
                            [icon]="'assets/svg/calendar.svg'"
                            formControlName="jobDate"
                            [form]="form.controls.jobDate"
                            errorMessage="Please enter a valid date."
                            [submitted]="submitted" />
                        </form>
                      </tidy-row>
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-select
                            [label]="firstJobTimeLabel"
                            [icon]="'assets/svg/time.svg'"
                            [form]="form.controls.jobTime"
                            formControlName="jobTime"
                            [items]="assignJobTimeItems" />
                        </form>
                      </tidy-row>
                    }
                    @if (selectedFrequency == 'twice_a_week' || selectedFrequency == 'thrice_a_week') {
                      @if (windowService.isDesktopRes) {
                        <tidy-row>
                          <form [formGroup]="form" novalidate action="#">
                            <div style="display: flex; justify-content: space-between">
                              <tidy-datepicker
                                [label]="'Second job date'"
                                [icon]="'assets/svg/calendar.svg'"
                                formControlName="jobSecondDate"
                                [form]="form.controls.jobSecondDate"
                                errorMessage="Please enter a valid date."
                                [submitted]="submitted"
                                style="flex: 1; padding-right: 5px;" />
                              <tidy-select
                                [label]="'Second job time'"
                                [icon]="'assets/svg/time.svg'"
                                [form]="form.controls.jobSecondTime"
                                formControlName="jobSecondTime"
                                [items]="assignJobTimeItems"
                                style="flex: 1; padding-left: 5px;" />
                            </div>
                          </form>
                        </tidy-row>
                      }
                      @if (!windowService.isDesktopRes) {
                        <tidy-row>
                          <form [formGroup]="form" novalidate action="#">
                            <tidy-datepicker
                              [label]="'Second job date'"
                              [icon]="'assets/svg/calendar.svg'"
                              formControlName="jobSecondDate"
                              [form]="form.controls.jobSecondDate"
                              errorMessage="Please enter a valid date."
                              [submitted]="submitted" />
                          </form>
                        </tidy-row>
                        <tidy-row>
                          <form [formGroup]="form" novalidate action="#">
                            <tidy-select
                              [label]="'Second job time'"
                              [icon]="'assets/svg/time.svg'"
                              [form]="form.controls.jobSecondTime"
                              formControlName="jobSecondTime"
                              [items]="assignJobTimeItems" />
                          </form>
                        </tidy-row>
                      }
                    }
                    @if (selectedFrequency == 'thrice_a_week') {
                      @if (windowService.isDesktopRes) {
                        <tidy-row>
                          <form [formGroup]="form" novalidate action="#">
                            <div style="display: flex; justify-content: space-between">
                              <tidy-datepicker
                                label="Third job date"
                                [icon]="'assets/svg/calendar.svg'"
                                formControlName="jobSecondDate"
                                [form]="form.controls.jobThirdDate"
                                errorMessage="Please enter a valid date."
                                [submitted]="submitted"
                                style="flex: 1; padding-right: 5px;" />
                              <tidy-select
                                [label]="'Third job time'"
                                [icon]="'assets/svg/time.svg'"
                                [form]="form.controls.jobThirdTime"
                                formControlName="jobSecondTime"
                                [items]="assignJobTimeItems"
                                style="flex: 1; padding-left: 5px;" />
                            </div>
                          </form>
                        </tidy-row>
                      }
                      @if (!windowService.isDesktopRes) {
                        <tidy-row>
                          <form [formGroup]="form" novalidate action="#">
                            <tidy-datepicker
                              label="Third job date"
                              [icon]="'assets/svg/calendar.svg'"
                              formControlName="jobSecondDate"
                              [form]="form.controls.jobThirdDate"
                              errorMessage="Please enter a valid date."
                              [submitted]="submitted" />
                          </form>
                        </tidy-row>
                        <tidy-row>
                          <form [formGroup]="form" novalidate action="#">
                            <tidy-select
                              [label]="'Third job time'"
                              [icon]="'assets/svg/time.svg'"
                              [form]="form.controls.jobThirdTime"
                              formControlName="jobSecondTime"
                              [items]="assignJobTimeItems" />
                          </form>
                        </tidy-row>
                      }
                    }
                    @if (!proServiceItems?.length && !showProChangeLoader) {
                      <tidy-row class="extra-bottom-padding">
                        <tidy-text
                          [body]="'This pro doesn\'t offer any services in this category. Please ask them to add services in this category.'"
                          class="red" />
                      </tidy-row>
                    }
                    @if (form?.value?.frequency == 'once') {
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-textarea
                            formControlName="jobNote"
                            [form]="form.controls.jobNote"
                            label="Job note (optional)"
                            [icon]="'assets/svg/information-circle.svg'" />
                        </form>
                      </tidy-row>
                    }
                    <dynamic-booking-form
                      #dynamicBookingForm
                      [forms]="forms"
                      [submitted]="submitted"
                      [hasImageUploadError]="hasImageUploadError"
                      [isLoading]="isLoadingDynamicForm"
                      (attachmentsChange)="onAttachmentsChange($event)"
                      (selectedCheckboxesChange)="onSelectedCheckboxesChange($event)"
                      (formDataChange)="onFormDataChange($event)" />
                  }
                }
                @if (form?.value?.pro == 'add_pro') {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-card>
                      <tidy-row>
                        <tidy-text
                          [body]="('Add a new pro to your ' | translate) + selectedServiceType?.viewValue.toLowerCase() + (' workflow at ' | translate) + (selectedAddress?.address_name ? (selectedAddress.address_name | translate) : (selectedAddress.address1 | translate)) + ':'" />
                      </tidy-row>
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-input
                            formControlName="newProName"
                            [label]="'Pro Name'"
                            [form]="form.controls.newProName"
                            [submitted]="submitted"
                            [errorMessage]="'Please enter a name.'"
                            [icon]="'assets/svg/person.svg'"
                            [activeIcon]="'assets/svg/person-outline-tidy-green.svg'" />
                        </form>
                      </tidy-row>
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-input
                            formControlName="newProEmail"
                            [label]="'Pro Email'"
                            [form]="form.controls.newProEmail"
                            type="email"
                            [submitted]="submitted"
                            [errorMessage]="'Please enter a valid email.'"
                            [icon]="'assets/svg/mail-outline.svg'"
                            [activeIcon]="'assets/svg/mail-outline-tidy-green.svg'" />
                        </form>
                      </tidy-row>
                      <tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-input-international-phone
                            formControlName="newProPhone"
                            [label]="'Pro Phone'"
                            [form]="form.controls.newProPhone"
                            [inputMode]="'numeric'"
                            [submitted]="submitted"
                            [errorMessage]="'Please enter a valid phone.'"
                            [icon]="'assets/svg/phone-portrait-outline.svg'"
                            [activeIcon]="'assets/svg/phone-portrait-outline-tidy-green.svg'"
                            [initialMask]="{ mask: '[00000000000000000000000]' }"
                            (countryCodeChange)="onCountryCodeChange($event)" />
                        </form>
                      </tidy-row>
                      <tidy-button
                        [text]="'Add Pro'"
                        [action]="boundAddNewPro"
                        class="secondary" />
                    </tidy-card>
                  </tidy-row>
                }
              }
            }
            @if (!showProChangeLoader && !showServiceChangeLoader) {
              <tidy-row>
                <tidy-button
                  [action]="boundSubmitForm"
                  [text]="getButtonText()"
                  class="primary"
                  [disabled]="!selectedPro || !proItems?.length || !proServiceItems?.length || (selectedTab == 'assign' && !selectedPro?.isPrivate)" />
              </tidy-row>
            }
            @if (probabilityData && selectedTab == 'request' && form?.value?.pro == 'all_my_pros' && !showProChangeLoader) {
              <tidy-alert class="agent-border" style="margin-top: 20px;">
                <tidy-row [align]="'center'" class="extra-bottom-padding">
                  <tidy-text [header]="'Acceptance Probability'" />
                </tidy-row>
                @if (!didSelectAllTimes) {
                  <tidy-row [align]="'center'">
                    <tidy-text [body]="'Select all times to see the estimated chance that a pro accepts your job.'" />
                  </tidy-row>
                }
                @if (didSelectAllTimes && probabilityData) {
                  <tidy-row [align]="'center'" class="extra-bottom-padding">
                    <tidy-text [body]="'Pro Search Agent estimates a '" />
                    <tidy-text [body]="probabilityData?.acceptance_probability + '%'" style="font-weight: bold;" />
                    <tidy-text [body]="' chance of a pro accepting.'" /><span>&nbsp;</span>
                    <tidy-text [actionBody]="'Learn More'" class="link" (action)="goToLearnMoreProbability()" />
                  </tidy-row>
                  @if (probabilityData?.acceptance_probability <= 98 && probabilityData?.factors?.length) {
                    <tidy-row [align]="'center'" class="extra-bottom-padding">
                      <tidy-text [body]="'To improve:'" />
                    </tidy-row>
                    <tidy-row style="display: flex; flex-direction: row; justify-content: center; flex-wrap: wrap;" [align]="'center'">
                      @for (factor of probabilityData?.factors; track factor) {
                        <tidy-card style="display: inline-block; width: auto; margin-right: 10px; margin-bottom: 10px;">
                          <tidy-row [align]="'center'">
                            <tidy-text [body]="factor?.factor" />
                          </tidy-row>
                        </tidy-card>
                      }
                    </tidy-row>
                  }
                }
              </tidy-alert>
            }
          }
        }

          </tidy-wrapper>
        </ng-template>

        @if (!isRightSideContent) {
          <app-scroll-wrapper [templateContent]="content" />
        }

        @if (isRightSideContent) {
          <ion-content class="ion-content-right-column">
            <ng-container *ngTemplateOutlet="content" />
          </ion-content>
        }
